<template>
    <div class="layout">
        <Layout>
            <Header>
                <Menu mode="horizontal" theme="dark" active-name="1" @on-select="langSwitch">
                    <div class="layout-logo"></div>
                    <div class="logout_box">
                        <Icon type="ios-contact" size="25" />
                        <div class="name">{{username}}</div>
                        <span class="fh">|</span>
                    <span class="logout" @click="logout">{{$t("menu.loginOut")}}</span>
                    </div>
                     <Submenu name="lang" style="float:right">
                          <template slot="title">
                            <Icon type="md-list" />{{$t("menu.lang")}}
                        </template>
                        <MenuItem name="zh">{{$t("menu.zh")}}</MenuItem>
                     </Submenu>

                </Menu>
            </Header>
            <Layout>
                <Sider hide-trigger :style="{background: '#fff'}">
                    <Menu
                        :active-name="active_nav"
                        theme="light"
                        width="200"
                        @on-select="select_nav"
                    >
                        <MenuItem name="1-1" to="home">
                            <Icon type="md-home" />
                            <span>{{$t('menu.index')}}</span>
                        </MenuItem>
                        <!--Submenu v-if="usertype==1" name="2">
                            <template slot="title">
                                <Icon type="md-settings" />{{$t('menu.systemSetting')}}
                            </template>
                            <MenuItem name="2-1" to="normal">{{$t('menu.normalSetting')}}</MenuItem>
                            <MenuItem name="2-2" to="coin">{{$t('menu.coinSetting')}}</MenuItem>
                            <MenuItem name="2-3" to="banner">{{$t('menu.bannerSetting')}}</MenuItem>
                            <MenuItem name="2-4" to="level">{{$t('menu.levelSetting')}}</MenuItem>
                            <MenuItem name="2-5" to="google">{{$t('menu.googleSetting')}}</MenuItem>
                            <MenuItem name="2-6" to="pay">{{$t('menu.payList')}}</MenuItem>
                        </Submenu-->
                        <MenuItem name="2-1" to="agent">
                            <Icon type="ios-list-box" />
                            <span>{{$t('menu.agentList')}}</span>
                        </MenuItem>
                       <MenuItem name="3-1" to="user">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.userList')}}</span>
                        </MenuItem>
                        <MenuItem name="4-1" to="bank">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.bankList')}}</span>
                        </MenuItem>
                        <MenuItem name="5-1" to="order">
                            <Icon type="md-list" />
                            <span>{{$t('menu.orderSetting')}}</span>
                        </MenuItem>
                        <MenuItem name="6-1" to="transaction">
                             <Icon type="ios-people" />
                             <span>{{$t('menu.transactionList')}}</span>
                        </MenuItem>
                        <MenuItem name="7-1" to="announcement">
                            <Icon type="md-person" />
                            <span>{{$t('menu.announcementSetting')}}</span>
                        </MenuItem>
                        <MenuItem name="8-1" to="notice">
                            <Icon type="md-person" />
                            <span>{{$t('menu.noticeSetting')}}</span>
                        </MenuItem>
                        <MenuItem name="9-1" to="deposit">
                            <Icon type="md-person" />
                            <span>{{$t('menu.depositList')}}</span>
                        </MenuItem>
                        <MenuItem name="10-1" to="withdraw">
                            <Icon type="md-person" />
                            <span>{{$t('menu.withdrawList')}}</span>
                        </MenuItem>
                        <MenuItem name="11-1" to="kefu">
                            <Icon type="md-person" />
                            <span>{{$t('menu.kefuList')}}</span>
                        </MenuItem>
                        <MenuItem name="12-1" to="level">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.payList')}}</span>
                        </MenuItem>
                        <MenuItem name="13-1" to="manager">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.managerList')}}</span>
                        </MenuItem>
                    </Menu>
                </Sider>
                <Layout :style="{padding: '24px'}">
                    <!-- <Breadcrumb :style="{margin: '24px 0'}">
                        <BreadcrumbItem>Home</BreadcrumbItem>
                        <BreadcrumbItem>Components</BreadcrumbItem>
                        <BreadcrumbItem>Layout</BreadcrumbItem>
                    </Breadcrumb>-->
                    <Content
                        :style="{padding: '24px', height: content_h, background: '#fff',overflowY: 'scroll'}"
                    >
                        <transition :name="transitionName">
                            <router-view />
                        </transition>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template>
<script>
export default {
    data() {
        return {
            content_h: 0,
            transitionName: "slide-right",
            active_nav: sessionStorage.getItem("active_nav") || "1-1",
            lang:"zh",
            usertype: 1,
            username: ""
        };
    },
    mounted() {
        this.content_h = document.documentElement.clientHeight - 115 + "px";
        this.usertype = localStorage.getItem('usertype');
        this.username = localStorage.getItem('username');
    },
    methods: {
        select_nav(name) {
            sessionStorage.setItem("active_nav", name);
        },
        langSwitch(name){
            console.log(name);
            window.localStorage.setItem('localeLanguage',name)
            document.cookie = 'locale='+name;
            //Vue.config.lang = name
            this.$i18n.locale = name
            //this.$i18n.setup(name);
        },
        logout() {
            this.$Modal.confirm({
                title: this.$i18n.t("menu.loginOutTitle"),
                content: "<p>"+this.$i18n.t("menu.loginOutContent")+"</p>",
                onOk: () => {
                    this.$post(this.$path.logout).then(res => {
                        if (res.success) {
                            this.$router.push({ name: "login" });
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.ivu-layout-header {
    padding-left: 0;
    height: 60px;
    line-height: 60px;
}
.layout-logo {
    width: 200px;
    height: 60px;
    line-height: 60px;
    float: left;
    padding-left: 15px;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    font-family: cursive;
}
.layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}
.ivu-layout-header {
    padding-right: 15px;
}
.logout_box {
    float: right;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
        margin-left: 5px;
    }
    .fh {
        margin: 0 10px;
    }
    .logout {
        font-size: 13px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/view.vue